import { Account } from "features/trading/accounts";
import { useListAccountsQuery } from "features/trading/accounts";
import { useState } from "react";
import { GridModel } from "features/api";
import SelectionModal from "./SelectionModal";

interface AccountSelectionModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (account: Account) => void;
}

const PAGE_SIZE = 10;

const AccountSelectionModal = ({ open, onClose, onSelect }: AccountSelectionModalProps) => {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const { data: accountsData, isLoading: isAccountsLoading, isFetching: isAccountsFetching } = useListAccountsQuery({
    pagination: {
      page: page - 1, // Convert to 0-based index
      pageSize: PAGE_SIZE
    },
    gridFilters: searchQuery ? {
      quickFilterValues: searchQuery
    } : undefined
  } as GridModel);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
    setPage(1); // Reset to first page when searching
  };

  return (
    <SelectionModal<Account>
      open={open}
      onClose={onClose}
      onSelect={onSelect}
      title="Select Account"
      searchPlaceholder="Search by account number or client name..."
      items={accountsData?.results}
      isLoading={isAccountsLoading}
      isFetching={isAccountsFetching}
      totalCount={accountsData?.count || 0}
      pageSize={PAGE_SIZE}
      currentPage={page}
      onPageChange={handlePageChange}
      onSearchChange={handleSearchChange}
      renderItem={(account) => ({
        primary: `${account.client__name} - ${account.account_number}`,
        secondary: account.custodian__name
      })}
    />
  );
};

export default AccountSelectionModal;
